import React, { useEffect } from 'react';

import { useAppDispatch } from '../../store';
import { fetchUsers } from '../../store/user_store';
import useStyles from './styles';
import PricingBannerMembers from './components/PricingBannerMembers';
import UsersTable from './Members/UsersTable';
import GroupsTable from './Members/GroupsTable';
import { TabManager } from '@clef/client-library';
import { useTypedSelector } from '../../hooks/useTypedSelector';

export const MembersV2: React.FC<{}> = () => {
  const styles = useStyles();
  const dispatch = useAppDispatch();
  const loginUser = useTypedSelector(state => state.login.user!);

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  return (
    <>
      <PricingBannerMembers />
      <div className={styles.membersContainer}>
        {loginUser.orgEnableGroup ? (
          <TabManager
            tabs={[
              {
                key: 'users',
                title: t('Users'),
                component: <UsersTable />,
              },
              {
                key: 'groups',
                title: t('Groups'),
                component: <GroupsTable />,
              },
            ]}
            tabQueryKey="membersTab"
            defaultTab="users"
          />
        ) : (
          <UsersTable />
        )}
      </div>
    </>
  );
};
export default MembersV2;
